import React from 'react';
import "./ArticleTitle.scss";

export default function ArticleTitle({article}) {
    return (
        <div className="article-title-widget">
            <h1>
                {article.title}
            </h1>
        </div>
    );
}